var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikedVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.47942H5.5V19.4794H0V7.47942ZM1 8.47942V18.4794H4.5V8.47942H1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1003 2.36398C14.4779 1.35702 13.2174 0.545297 12.4569 1.30575L5.5 8.26265V18.4795H14.7086C15.836 18.4795 16.8239 17.725 17.1205 16.6373L18.8286 10.3742C19.0889 9.42 18.3706 8.47953 17.3815 8.47953H12.5285C12.3645 8.47953 12.2109 8.39912 12.1175 8.26433C12.0241 8.12954 12.0028 7.95752 12.0603 7.80397L14.1003 2.36398ZM4.84413 7.50431L11.7498 0.598647C13.2707 -0.922255 15.7919 0.701164 15.0367 2.7151L13.25 7.47953H17.3815C19.0299 7.47953 20.2271 9.04698 19.7934 10.6373L18.0853 16.9004C17.67 18.4232 16.2869 19.4795 14.7086 19.4795H5C4.72386 19.4795 4.5 19.2557 4.5 18.9795V7.97953C4.5 7.75782 4.64431 7.5698 4.84413 7.50431Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikedVideos);
export default __webpack_public_path__ + "static/media/LikedVideos.b2a48942153236966d61e0b266c65046.svg";
export { ForwardRef as ReactComponent };